import Sentry from "@similarweb/sentry-logger";

import { PdfExportService } from "app/services/PdfExportService";

import type { MetricKey } from "../../types";
import { METRIC_CONFIGURATION } from "../config";

const DEFAULT_OFFSET = {
    x: 0,
    y: 0,
};

const DEFAULT_WIDTH = 1366;
const DEFAULT_HEIGHT = 450;

export const exportChartAsPNG = async (
    chartElement: HTMLElement,
    selectedMetric: MetricKey,
    timeGranularity: string,
): Promise<void> => {
    if (!chartElement) {
        throw new Error("Chart element not found");
    }

    const styleHTML = PdfExportService.getStylesheetsForPng();

    let height = chartElement.offsetHeight + 30;
    height = isNaN(height) ? DEFAULT_HEIGHT : height;

    const metricConfig = METRIC_CONFIGURATION[selectedMetric];
    const fileName = metricConfig?.metricName || "Chart";

    try {
        await PdfExportService.downloadHtmlPngFedService(
            styleHTML + chartElement.outerHTML,
            fileName,
            DEFAULT_WIDTH + DEFAULT_OFFSET.x,
            height + DEFAULT_OFFSET.y,
        );
    } catch (error) {
        Sentry.errorTracker({
            message: "Error downloading PNG for HighLevelMetricsComparisonChart",
            e: error,
            params: {
                extra: {
                    metricName: selectedMetric,
                    timeGranularity,
                },
            },
        });
        throw error;
    }
};
